import React, { PropTypes } from 'react';
import _ from 'lodash';
import  { RetrievalButton } from '../../../../../common/components/c_SourceSimpleFileInput';
import ProgressComponentList from '../../../../../common/components/C_ProgressComponentList';
import TextField from '../../../../../common/components/c_TextField';
import DropDown from '../../../../../common/components/c_DropDownMenu';

export default class DocumentItem extends ProgressComponentList {

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: props.validation
    };

    this.handleTextFieldUI = this.handleTextFieldUI.bind(this);
    this.handleDropDownMenuUI = this.handleDropDownMenuUI.bind(this);

  }
  
  static propTypes = {
    document: PropTypes.object,
    staticData: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
  }

  handleUpdate = (clientId, prop) => {
    return (model, field, event, value) => this.props.onChange(clientId, prop, event, value);
  }

  handleTextFieldUI = (clientId, prop, label) => {

    return {
     'data-id': prop,
      defaultValue: _.get(this.props.document, prop),
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onBlur: this.validateUpdate(this.props.model, prop, this.handleUpdate(clientId, prop))
    };
  }

  handleDropDownMenuUI = (clientId, prop, staticData, label) => {

    return {
      'data-id': prop,
      value: _.get(this.props.document, prop),
      menuItems: typeof staticData === 'string' ? this.props.staticData[staticData] : staticData,
      floatingLabelText: label,
      validation: this.props.validation[prop],
      errorText: _.get(this.state, `validation.${prop}.errors[0]`),
      onBlur: this.validateUpdate(this.props.model, prop, this.handleUpdate(clientId, prop))
      
    };
  }


  handleRemove = (clientId) =>
    (event) => this.props.onRemove(clientId)

  // Override ValidatedForm.formModel method
  get formModel() {
    const document =  _.get(this.props, 'document');
    const tempStateDocument = _.get(this.props, `tempState.documents[${document.clientId}]`);
    return _.merge({}, document, tempStateDocument);
  }

  render() {
    
    const {document} = this.props;
    const {fileName, storagePath, fileSize} = document;
    const docTypes = this.props.staticData.applicantDocumentFileTypes.filter((ft)=>ft.name !== "Assessment");

    return (
              <div className='documents form-contents'>
                
                <RetrievalButton
                  className='file-get'
                  loadingClass=''
                  notLoadingClass=''
                  failureClass=''
                  autoLoad
                  noMessage
                  path={storagePath}
                  signingRoute='/api/s3/get-sign'
                >
                  <TextField
                    disabled
                    floatingLabelText='File Name'
                    value={fileName}
                    inputStyle={{
                      textOverflow: 'ellipsis',
                      maxWidth: '76%'
                    }}
                  />
                  <span className='megabyte-count'>
                    {`${Math.max(Math.round(fileSize/100000)/10, 0.1)} Mgb`}
                  </span>
                </RetrievalButton>
                <DropDown
                  containerStyle={{
                    width: 'calc(33.3% - 40px)'
                  }}
                  {...this.handleDropDownMenuUI(document.clientId, 'fileTypeId', docTypes, 'File Type')}
                />
                <TextField
                  optional
                  style={{
                    width: 'calc(33.3% - 40px)'
                  }}
                  {...this.handleTextFieldUI(document.clientId, 'description', 'File Description')}
                />
                <div
                  data-id='remove-section'
                  className='remove-section text-btn noTextSelect'
                  onClick={this.handleRemove(document.clientId)}
                >
                  Remove
                </div>
              </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/c_Documents/DocumentItem.js